import React from 'react';
import { Modal } from 'antd';
import s from './s.module.less';
import { getAskChartDemoUrl } from 'constants/common';
import demoGif from './imgs/askchart-demo.gif';

type Props = {
    open: boolean;
    onClose: () => void;
};

const AskChartWelcomeModal = (props: Props) => {
    const { open, onClose } = props;

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={1080}
            centered
            closable={false}
            className={s.modalWrap}
            destroyOnClose
        >
            <div className={s.container}>
                <div className={s.left}>
                    <img src={demoGif} alt="AskChart demo" className={s.demo} />
                </div>
                <div className={s.right}>
                    <span
                        className={s.close}
                        onClick={onClose}
                        role="button"
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M5 15L15 5M5 5L15 15" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <div className={s.badge}>NEW</div>
                    <div className={s.title}>
                        Meet <span className={s.brand}>AskChart</span>, your AI-powered practice assistant
                    </div>
                    <div className={s.des}>
                        AskChart, <b>from Klarity Health</b>, is a new AI assistant that works alongside Klarity and your other EHRs to handle your daily admin, from billing and scheduling to patient messaging. <b>Start with 500 free credits.</b>
                    </div>
                    <ul className={s.features}>
                        <li>
                            <span className={s.check}>✓</span>
                            <div>
                                <div className={s.featureTitle}>Cut insurance billing costs in half</div>
                                <div className={s.featureDes}>AskChart charges 3.9% per claim, about half what most billers charge.</div>
                            </div>
                        </li>
                        <li>
                            <span className={s.check}>✓</span>
                            <div>
                                <div className={s.featureTitle}>Works with all your patients, not just Klarity&apos;s</div>
                                <div className={s.featureDes}>AskChart handles billing, messaging, and scheduling for every patient across every EHR you use.</div>
                            </div>
                        </li>
                        <li>
                            <span className={s.check}>✓</span>
                            <div>
                                <div className={s.featureTitle}>Sync Klarity to your other EHR</div>
                                <div className={s.featureDes}>Your Klarity patients and appointments sync automatically to Healthie, IntakeQ, Tebra, SimplePractice and more EHRs.</div>
                            </div>
                        </li>
                        <li>
                            <span className={s.check}>✓</span>
                            <div>
                                <div className={s.featureTitle}>Tell AskChart what to do, in your own words</div>
                                <div className={s.featureDes}>Type &quot;Check my pending claims&quot; or &quot;Message tomorrow&apos;s patients&quot; and AskChart handles the rest.</div>
                            </div>
                        </li>
                    </ul>
                    <div className={s.ctas}>
                        <a className={s.primaryBtn} href="https://app.askchart.ai/signup" target="_blank" rel="noopener noreferrer">
                            Try AskChart
                        </a>
                        <a className={s.secondaryBtn} href={getAskChartDemoUrl()} target="_blank" rel="noopener noreferrer">
                            Book a demo
                        </a>
                        <a className={s.tertiaryBtn} href="https://askchart.ai" target="_blank" rel="noopener noreferrer">
                            Learn more →
                        </a>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AskChartWelcomeModal;